import React, { useState } from "react";
import "./styles.css";

function About(){

    
 return(  
   <div>
    <div id="aboutus" className="initialabout">
    <h1 className="nothing">heyyy</h1>
    <h1 className="heading">OUR <span className="bold" > THOUGHTS</span></h1>
    <svg className="head-image" src="../images/ic.svg"></svg>
    <p className="info">
      We aim to create a community of tech enthusiasts who can grow and build together. We believe,
      if we can do it, you can do it too.
      <h4 className="team">~UmbrellaOfCode</h4>
    </p>
     
    <hr className="mainhr"/>
         <div className="teamicon">
           <button className="teamiconind" title="umbrellaofcode@gmail.com"><a  href="mailto:umbrellaofcode@gmail.com"  target="_blank"><img src="../images/mail.svg"/></a></button>
           <button className="teamiconind"><a  href="https://www.instagram.com/umbrellaofcode/"  target="_blank"><img src="../images/instagram.svg"/></a></button>
           </div>
      <div className="box" >
          <h1 className="box-heading"> <span className="bold" >Our</span>&nbsp;Core Values</h1>

             <div className="row">
                 <img className="side-image" src="../images/h.svg"/ > 
                 <div className="group2">
                    <p className="head"><span className="bold2">Customer</span> Support</p>
                    <p className="text">
                       Your vision matter the most to us, we will try to step into your shoes
                       and  get a clear insight of your requirements and ideas so that you get what you truely want
                       You think we deliver... Cheers!!
                    </p>
                 </div>  
                 <hr  className="hr"/>
              </div>  
  
    

              <div className="row">
                  <img className="side-image2" src="../images/user__interface.svg"/ >
                  <div className="group2">
                  <p className="head1"  ><span className="bold2">Unique</span> Styling</p>
                  <p className="text"  >
                      Styling which is customised according to the need of the consumer so 
                      that your web designs is as unique as your idea. We aim at delivering a user interface that 
                      is simple and elegant..
                   </p>   
                  </div>
                  <hr  className="hr"/> 
              </div> 

    
    
             <div className="row">
              <img className="side-image" src="../images/c.svg"/> 
                  <div className="group2">
                  <p className="head"><span className="bold2">Responsive</span> Designs</p>
                  <p className="text">
                      Hassle free content management with websites that are built to be functional for a wide range 
                      of devices.This will make the website accessible by various users..
                  </p>
                  </div>
               <hr  className="hr"/>
             </div>  
      
      </div>




      <div>
          <h1 className="meet-team">Meet<span className="bold">&nbsp; The Team..</span></h1>
          
             <img className="card" src="../images/b1.png"/ >
             <img className="smallcard" src="../images/s1.png"/ > 
             <div className="contacticon">
           <button className="contactindiv" title="seeratmakhija1@gmail.com"><a  href="mailto:seeratmakhija1@gmail.com"  target="_blank"><img  src="../images/mail.svg"/></a> </button>
           <button className="contactindiv"><a  href="https://www.instagram.com/seerat_makhija/"  target="_blank"><img src="../images/instagram.svg"/></a> </button>
           <button className="contactindiv"><a  href="https://www.linkedin.com/in/seerat-makhija-8a8854196/"  target="_blank"><img src="../images/linkedin.svg"/></a></button>
      </div>
            <img className="card" src="../images/b2.png"/ > 
            <img className="smallcard" src="../images/finaltanmay.png"/ > 
            <div className="contacticon">
           <button className="contactindiv" title="tanmay.mishra.1782@gmail.com"><a  href="mailto:tanmay.mishra.1782@gmail.com"  target="_blank"><img src="../images/mail.svg"/></a></button>
           <button className="contactindiv"><a  href="https://www.instagram.com/tanmaymishraa/"  target="_blank"><img src="../images/instagram.svg"/></a></button>
           <button className="contactindiv"><a  href="https://www.linkedin.com/in/tanmay-mishra-17235b1a1/"  target="_blank"><img src="../images/linkedin.svg"/></a></button>
      </div>
        
          
            
      </div>
     
           <div>
             <p className="footer">copyright@2020</p>
           </div>
    </div>

 </div>
 );
}

export default About;